import experience from "../data/experience";

const Experience = () => {
  return (
    <section id="experience" className="section">
      <div className="container">
        <h2 className="headline-2 reveal-up">Working Experience</h2>
        <p className="text-zinc-400 mt-3 mb-8 max-w-[50ch] reveal-up">
          Roles where I built full-stack systems, streamlined operations, and
          delivered measurable impact for teams and users.
        </p>

        <div className="flex flex-col gap-6">
          {experience.map(
            ({
              title,
              company,
              companyUrl,
              logoSrc,
              employmentType,
              startDate,
              endDate,
              location,
              highlights,
            }) => (
              <article
                key={`${company}-${startDate}`}
                className="bg-zinc-800/50 p-7 rounded-2xl md:p-10 reveal-up"
              >
                <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between md:gap-8 mb-5">
                  <div className="flex items-start gap-4">
                    <figure className="bg-zinc-700/50 rounded-xl overflow-hidden w-12 h-12 shrink-0 p-1.5">
                      <img
                        src={logoSrc}
                        alt={`${company} logo`}
                        width={48}
                        height={48}
                        loading="lazy"
                        className="w-full h-full object-contain"
                      />
                    </figure>

                    <div>
                      <h3 className="text-lg font-semibold text-zinc-100 md:text-xl">
                        {title}
                      </h3>
                      <p className="mt-1 text-zinc-300">
                        {companyUrl ? (
                          <a
                            href={companyUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="text-sky-400 transition-colors hover:text-sky-300"
                          >
                            {company}
                          </a>
                        ) : (
                          <span className="text-sky-400">{company}</span>
                        )}
                        <span className="text-zinc-500"> | </span>
                        {employmentType}
                      </p>
                    </div>
                  </div>

                  <div className="text-sm text-zinc-400 md:text-right shrink-0 pl-16 md:pl-0">
                    <p>
                      {startDate} – {endDate}
                    </p>
                    <p>{location}</p>
                  </div>
                </div>

                <ul className="flex flex-col gap-3 text-zinc-300 text-sm md:text-base">
                  {highlights.map((item) => (
                    <li key={item} className="flex gap-3">
                      <span className="text-sky-400 mt-1.5 shrink-0">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </article>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Experience;
